import { render, staticRenderFns } from "./ScanBatches.vue?vue&type=template&id=6f018cc2"
import script from "./ScanBatches.vue?vue&type=script&lang=js"
export * from "./ScanBatches.vue?vue&type=script&lang=js"
import style0 from "./ScanBatches.vue?vue&type=style&index=0&id=6f018cc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports